import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./mod_price_option_display_style.js";
//#region src/mod_price_option_display_style_helper.ts
var mod_price_option_display_style_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(modPriceOptionDisplayStyle) {
	switch (modPriceOptionDisplayStyle) {
		case "row": return "Row";
		case "column": return "Column";
	}
}
//#endregion
export { mod_price_option_display_style_helper_exports, name };

//# sourceMappingURL=mod_price_option_display_style_helper.js.map